import { render, staticRenderFns } from "./upImgnew.vue?vue&type=template&id=d5d0d4d6&scoped=true"
import script from "./upImgnew.vue?vue&type=script&lang=js"
export * from "./upImgnew.vue?vue&type=script&lang=js"
import style0 from "./upImgnew.vue?vue&type=style&index=0&id=d5d0d4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d0d4d6",
  null
  
)

export default component.exports